module.exports = __webpack_public_path__ + "3734d3ffd0a18a1b7cc2500b84a36fd6.svg";